import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/**
 * Layout: `/confirm-account/verify` OTP step requires {@link Outlet}.
 */
const ConfirmAccountLayout = () => <Outlet />;

export const Route = createFileRoute("/_auth/confirm-account")({
    component: ConfirmAccountLayout,
    beforeLoad: ({ context }) => {
        if (context?.auth?.isAuthenticated === true) {
            throw redirect({
                to: "/change-password",
            });
        }
        return context;
    },
});
